import React from "react";
import logo from "../assets/logo.webp";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-blue-600 text-white py-12 px-4 lg:px-32 w-full rounded-md">
      {/* Bottom Section */}
      <div className="flex flex-col md:flex-row justify-between items-center">
        <div className="flex items-center gap-2">
          <img src={logo} alt="logo" className="w-10" />
          <span className="text-xl">HYVIRU</span>
        </div>

        <p className="mt-2 md:mt-0">
          © {currentYear} HYVIRU | All Rights Reserved
        </p>

        <div className="flex gap-6 mt-4 md:mt-0">
          <FaFacebookF
            className="cursor-pointer hover:text-gray-300"
            size={24}
          />
          <FaTwitter className="cursor-pointer hover:text-gray-300" size={24} />
          <FaInstagram
            className="cursor-pointer hover:text-gray-300"
            size={24}
          />
          <FaLinkedinIn
            className="cursor-pointer hover:text-gray-300"
            size={24}
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
